import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Paper
} from '@material-ui/core'
import { obtenerReporteClientesRegistrohAction } from '../../../ducks/reporteClientesDuck'
import { offLoadAction, onLoadAnction } from '../../../ducks/loadDuck'
import { FormatoFechaIso } from '../../../utils/FormatFecha'


const columns = [
    { field: "1", headerName: "Cliente" },
    { field: "2", headerName: "Email Cliente" },
    { field: "3", headerName: "Telefono" },
    { field: "4", headerName: "Agente" },
    { field: "5", headerName: "Email agente" },
    { field: "6", headerName: "Fecha registro" },
]
const useObtenerReporteClientesRegistro = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerReporteClientesRegistrohAction()).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch])
}
const IntentoRegistro = () => {
    const rows = useSelector((store) => store.reporteClientes.clientes)
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    useObtenerReporteClientesRegistro()
    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10))
        setPage(0)
    }

    return (
        <Paper>
            <TableContainer>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell align='center' key={column.field}>{column.headerName}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, index) => (
                                <TableRow key={row?.IdBitacoraCliente}>
                                    <TableCell align='center'>{row?.Nombre}</TableCell>
                                    <TableCell align='center'>{row?.EMail}</TableCell>
                                    <TableCell align='center'>{row?.Telefono}</TableCell>
                                    <TableCell align='center'>{`${row?.User?.Nombres} ${row?.User?.ApellidoPaterno} ${row?.User?.ApellidoMaterno}`}</TableCell>
                                    <TableCell align='center'>{row?.User?.Correo}</TableCell>
                                    <TableCell align='center'>{FormatoFechaIso({date: row?.FechaRegistro, formato: "dd/MM/yyyy hh:mm aaaaa'm'"})}</TableCell>
                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    )
}
export default IntentoRegistro